import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";

const AlertDetailsModal = ({ isOpen, onClose, alert, label, view }) => {
  if (!isOpen || !alert) return null;
console.log(alert)
  const isGuideline = alert?.guideline_reference && view === 1;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-xl rounded-lg shadow-lg relative p-6 text-center">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none"
          onClick={onClose}
          aria-label="Close modal"
        >
          <FontAwesomeIcon icon={faTimes} className="text-lg" />
        </button>

        {isGuideline ? (
          <>
            <h2 className="text-blue-700 font-semibold text-lg mb-1">Clinical Guideline</h2>
            <hr className="mb-4" />

           <div className="text-5xl mb-4">📖</div>

            <p className="font-semibold text-sm text-gray-900 mb-1">
              {alert.guideline_reference?.source || "Clinical Guideline Reference"}
            </p>
            <p className="text-gray-700 text-sm mb-4">
              Access the complete clinical guideline and evidence-based recommendations.
            </p>

            <div className="bg-gray-100 text-gray-600 text-sm p-2 rounded mb-4 break-words">
              {alert.guideline_reference?.link}
            </div>

            <div className="flex justify-center gap-3">
              <a
                href={alert.guideline_reference?.link}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-md"
              >
                Open Guideline
              </a>
              <button
                onClick={onClose}
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm px-4 py-2 rounded-md"
              >
                Close
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-lg font-semibold text-blue-700 mb-3 border-b pb-2 text-start">
              {label ? `${label} Result` : alert?.label ? `${alert.label} Alert` : ''}
            </h2>

            <p className="text-gray-900 text-sm font-bold text-start">{alert?.label || alert?.test}</p>

            {alert?.type && (
              <div className="mb-2 flex items-center gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">Type:</p>
                <p className="text-gray-900 text-sm">{alert?.type}</p>
              </div>
            )}

            {alert?.text && (
              <div className="mb-2 flex items-center gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">Description:</p>
                <p className="text-gray-900 text-sm">{alert?.text}</p>
              </div>
            )}

            {!alert?.type && !alert?.text && alert?.risk && (
              <div className="mb-2 flex items-center gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">Full Description:</p>
                <p className="text-gray-900 text-sm">{alert?.risk}</p>
              </div>
            )}

            {!alert?.type && !alert?.text && !alert?.risk && (
              <div className="mb-2 flex items-center gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">Current Value:</p>
                <p className="text-gray-900 text-sm">{alert?.value || alert?.result}</p>
              </div>
            )}

            {alert.guideline_reference && view !== 1 && (
              <div className="bg-gray-50 p-4 rounded-md border border-gray-200 mt-2 text-start">
                <p className="text-gray-900 text-sm font-bold mb-1">📖 Guideline Reference</p>
                <p className="text-gray-900 text-sm font-bold mb-2">
                  {alert.guideline_reference.source}
                </p>
                <a
                  href={alert.guideline_reference.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium underline"
                >
                  View Guidelines →
                </a>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AlertDetailsModal;
